import { ua } from './modules/ua'
import inView from 'in-view'

const klass = {
  active: 'is-active',
  fixed: 'is-fixed',
  view: 'is-view',
  selected: 'is-selected',
  hidden: 'is-hidden',
  eventNone: 'is-eventNone',
  landscape: 'is-landscape',
  current: 'is-current',
  large: 'is-large',
  nav: 'view-nav',
}

class App {
  constructor() {
    this.body = document.querySelector('body')
    this.init()
  }

  init() {
    this.initPages()
  }

  initPages() {
    // 全ページ共通適用
    this.body.classList.add(`is-${ua.browser()}`)
    this.body.classList.add(`is-${ua.os()}`)

    // ナビゲーション開閉
    // document.querySelector('.nav-trigger').addEventListener('click', () => {
    //   document.querySelector('body').classList.toggle(klass.nav)
    // })

    // ナビゲーションを押下時に閉じる
    // Array.from(document.querySelectorAll('#gNav .mainNav a')).forEach((trigger) => {
    //   trigger.addEventListener('click', () => {
    //     document.querySelector('body').classList.toggle(klass.nav)
    //   })
    // })

    inView('.inview').on('enter', (el) => {
      el.classList.add('is-view')
    })
    inView.offset(100)

    window.addEventListener('scroll', () => {
      if (window.scrollY > 200) {
        document.querySelector('body').classList.add('is-scroll')
      } else {
        document.querySelector('body').classList.remove('is-scroll')
      }
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.sp24 = new App()
})

window.addEventListener('load', () => {
  document.querySelector('body').classList.add('is-loaded')
})
